import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With over 27 years of experience in banking and executive leadership, your
                insights span across different markets. How has your experience shaped your
                perspective on financial sector development in the Gulf, and what key lessons can be
                applied to drive innovation and resilience in regional banking ecosystems?
              </strong>
            </h5>

            <h5 className="text-white">
              My experience across diverse markets has provided me with a unique perspective on how
              financial sectors evolve under varying regulatory, technological, and socio-economic
              conditions. In the GCC region, the financial sector is notably well-capitalized,
              supported by strong regulatory oversight and ambitious national visions that are
              propelling digital and economic transformation. Additionally, the banking sector
              demonstrates resilience and a commitment to adopting international best practices.
              Looking ahead, a critical priority will be addressing the needs of the younger
              generation by accelerating digitalization and ensuring seamless integration to deliver
              a superior, future-ready customer experience.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- As an active member of the Finance & Insurance Committee at the Oman Chamber of
                Commerce & Industry, you are closely engaged with the banking, finance, and
                insurance sectors. What strategic opportunities do you see emerging for these
                industries across the GCC? And how are key players positioning themselves to compete
                and collaborate within this rapidly evolving landscape?
              </strong>
            </h5>
            <h5 className="text-white">
              GCC’s banking, finance, and insurance sectors are experiencing significant
              transformation driven by national economic diversification agendas, digitalization,
              and changing customer expectations. Strategic opportunities lie in open banking,
              digital platforms, and enhanced financial inclusion particularly targeting SMEs and
              the younger, tech-savvy population. Banks and insurance companies are increasingly
              leveraging data analytics, AI, and fintech/Insurtech partnerships to offer agile,
              personalized, and efficient services.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your advisory role at Oman’s National Program for Fiscal Sustainability Financial
                Sector Development (Estidamah)/Ministry of Finance signals a deep engagement with
                public sector reform and fiscal transformation. What are the most critical areas of
                alignment between the private banking sector and government financial strategies,
                particularly in achieving long-term economic sustainability and diversification?
              </strong>
            </h5>
            <h5 className="text-white">
              A strong alignment between government financial strategies and the private banking
              sector is essential to achieving long-term sustainability and economic
              diversification. One key area is directing credit and investment into priority non-oil
              sectors such as tourism, logistics, healthcare, and technology. Government frameworks,
              like sectoral lending targets and capital incentives, are enabling banks to support
              real economic growth in line with Oman Vision 2040.
              <br />
              <br />
              Another critical focus is the development of the SME sector. Through initiatives under
              Estidamah, such as SME support platform, credit scoring, private equity growth fund,
              and support for non-banking financial institutions, the public and private sectors are
              working together to improve access to finance for SMEs, which are central to job
              creation and innovation.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You are actively involved in academia as a member of the Industry Advisory Board
                at Muscat College, a guest lecturer at the College of Banking & Financial Studies
                and Modern College of Business & Science, as well as being projects’ assessor for
                the Etimad leadership development program at the Royal Academy of Management. What
                subjects do you typically teach or mentor in these roles, and how do you believe
                this academic engagement contributes to shaping the next generation of leaders to
                advance the financial sector in the Sultanate of Oman?
              </strong>
            </h5>
            <h5 className="text-white">
              In my academic and advisory roles, I primarily focus on subjects related to financial
              sector development, innovation, AI, fintech, and digital banking. I aim to bridge the
              gap between theory and practice bringing practical insights from my experience in
              banking, government advisory, and financial regulation into the classroom. <br />
              <br />
              My engagement with reputable educational institutions like Muscat College, the College
              of Banking & Financial Studies, and Modern College of Business & Science allows me to
              contribute to shaping future leaders who are not only academically prepared but also
              attuned to the evolving dynamics of the financial sector. I also see my role in the
              Etimad program at the Royal Academy of Management as a way to nurture leadership
              capabilities among high-potential professionals who will be instrumental in
              implementing Oman’s national vision.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
